import { Component, OnInit } from '@angular/core';
import {ServiceTypeService} from '../../../services/service-type/service-type.service';
import {DataTableService} from '../../../modules/UIKit/components/dataTable/dataTable.service';
import {TranslateService} from '@ngx-translate/core';
import {DataTableField} from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import {ServiceType} from '../../../models/service-type.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-service-type',
  templateUrl: './service-type.component.html',
  styleUrls: ['./service-type.component.css'],
  providers: []
})
export class ServiceTypeComponent implements OnInit {

  selectedServiceType: ServiceType = null;
  serviceTypeListTitles: DataTableField[];
  newDataAvailable = false;
  modalTitle = '';
  labels = {};
  public showAddOrEdit = false;
  public clientPagination = KontableComponent.ClientPagination;

  constructor(public srvServiceType: ServiceTypeService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {
    this.translate.get(['serviceTypeList']).subscribe((res) => {
      console.log(res);
      this.serviceTypeListTitles = [
        { id: 'id', label: '#' },
        { id: 'name', label: res.serviceTypeList.name },
        { id: 'description', label: res.serviceTypeList.description }
      ];
    });
  }

  ngOnInit() {

    this.translate.get([
      'serviceTypeList.add_title',
      'serviceTypeList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['serviceTypeList.add_title'];
      this.labels['edit_title'] = res['serviceTypeList.edit_title'];
    });

    this.srvServiceType.getAll().subscribe();
  }

  refresh () {
    this.srvServiceType.getAll().subscribe( () => {
      this.newDataAvailable = true;
    });
  }

  showAddEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvServiceType.serviceTypeEditing = data == null ? new ServiceType() : data;
    this.showAddOrEdit = true;
  }

  delete (record): void {
    this.srvServiceType.delete(record).subscribe( () => {
      this.refresh();
    });
  }


  serviceTypeAdded($event): void {
    this.srvServiceType.post($event).subscribe(() => {
      this.srvDataTable.get('dt_serviceType').showDetail = false;
      this.srvServiceType.serviceTypeEditing = null;
      this.refresh();
    });
  }

  serviceTypeUpdated($event): void {
    this.srvServiceType.put($event).subscribe(() => {
      this.srvDataTable.get('dt_serviceType').showDetail = false;
      this.srvServiceType.serviceTypeEditing = null;
      this.refresh();
    })
  }

  closeDialog (event) {
    if (event === true) {
      this.showAddOrEdit = false;
      this.refresh();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/service-type/service-type.component.ts